module.exports = __webpack_public_path__ + "static/media/aktuelles.1f5ff540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/aktuelles.svg
// module id = 913
// module chunks = 0